<template>
    <div />
</template>

<script setup lang="ts">
import type { HblCms } from '@/utils/types'
import { computed } from 'vue'
import { useHead, useSeoMeta } from '#app'
import { normalizeSlashes } from '@/utils/helper'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
    data: HblCms
}>()

const route = useRoute()
const config = useRuntimeConfig().public

const canonicalUrl = normalizeSlashes(config?.appBaseUrl + route?.path)
const ogTitle = computed(() => props.data.metaTitle ?? props.data.name)
const ogImage = computed(() => props.data.media?.url)

useSeoMeta({
    description: () => props.data.metaDescription,
    ogType: 'website',
    ogSiteName: ogTitle,
    ogTitle,
    ogDescription: () => props.data.metaDescription,
    ogUrl: canonicalUrl,
    ogImage,
    ogImageAlt: ogTitle
})

useHead({
    title: (props.data.metaTitle ?? props.data.name) + ' | ' + t('page.title'),
    link: [
        {
            rel: 'canonical',
            href: canonicalUrl
        }
    ]
})
</script>
